// This file exports your Firebase configuration object.
// We use a named export 'localFirebaseConfig' to match the import in HealthAIApp.jsx

export const localFirebaseConfig = {
    apiKey: "AIzaSyD8gTCE_-3uvGNmY1GkXz0o7ZDQd_tY1Qs",
    authDomain: "healthaiapp-8cfac.firebaseapp.com",
    projectId: "healthaiapp-8cfac",
    storageBucket: "healthaiapp-8cfac.firebasestorage.app",
    messagingSenderId: "360817615915",
    appId: "1:360817615915:web:b5d068b68f283f9ae4766e",
    measurementId: "G-G6FGTX8LBM"
};
